export type ReasonsForDisablingSpin = string | symbol;

export type SlotEvents = {
    'General.Slot.SPIN.DISABLE': ReasonsForDisablingSpin | void;
    'General.Slot.SPIN.ENABLE': ReasonsForDisablingSpin | void;
    'General.Slot.TRANSIT_BG_TO_FREESPINS': void;
    'General.Slot.TRANSIT_BG_TO_BASEGAME': void;
};
